module.exports = __webpack_public_path__ + "assets/images/glassShade-01.993d8915bcc1eec932762f6d30a59940.svg";